import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'
import CustomProgressBar from '../../../shared/components/CustomProgressBar'
import Clickable from '../Clickable'

import panelStyle from 'Styles/panel.css'
import progressBarStyle from 'Styles/progress-bar.css'
import style from './style.css'

import caretRight from 'Assets/caret-right-acqua.svg'
import caretDown from 'Assets/caret-down-acqua.svg'
import blackDot from 'Assets/dot.svg'
import redDot from 'Assets/redDot.svg'
import yellowDot from 'Assets/yellowDot.svg'
import greenDot from 'Assets/greenDot.svg'
import iconStyle from 'Styles/icon.css'

function StudyPlanItemExpanded (props) {
  return (
    <div>
      <p className={style.topicTitle}>
        Readings
      </p>
      <span className={props.studyPlan.length ? style.noItemsMsgDisabled : style.noItemsMsg}>
        No items available.
      </span>
      <ul className={style.suggestionList}>
        {_.map(props.studyPlan, item => {
          if (item.itemType === 't_item') {
            return null
          }
          const itemClass = item.itemType === 'ebook' ? style.ebookItem : style.suggestionItem
          return (
            <li
              data-test-id="studyPlanItemSuggestions"
              className={itemClass}
              key={item.displayValue}
            >
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                className={props.disableLinks ? style.studyNameDisabled : style.studyName}
                onClick={props.disableLinks ? null : () => props.itemClick(item)}
                tabIndex="0"
                dangerouslySetInnerHTML={{ __html: item.displayValue }}
              />
            </li>
          )
        })}

      </ul>
    </div>
  )
}
StudyPlanItemExpanded.propTypes = {
  studyPlan: PropTypes.array,
  disableLinks: PropTypes.bool,
  isStandalone: PropTypes.bool,
  itemClick: PropTypes.func
}

function StudyPlanItemDisabled (props) {
  return (
    <div
      data-test-id="studyPlanItem"
      className={classnames(panelStyle.small, style.studyPanel, style.disabledPanel)}
      tabIndex="0"
    >
      <div
        data-test-id="studyPlanItemTitle"
        className={style.disabled}
        dangerouslySetInnerHTML={{ __html: props.label }}
      />
      <div className={style.disabledText}>
        Questions on this topic are hidden.
      </div>
    </div>
  )
}

StudyPlanItemDisabled.propTypes = {
  label: PropTypes.string.isRequired
}

function renderBlackDot (labelValues, labelPostions, selectedStudent, isClassScoreSelected, isOriginalScoreSelected) {
  if (selectedStudent && (isClassScoreSelected || (isOriginalScoreSelected && selectedStudent.activity_state.rt))) {
    return (
      <div className={style.progressBarLabels} style={labelPostions}>
        <img src={blackDot} />
        <p>{labelValues}</p>
      </div>
    )
  }
  return null
}

function renderGradedDot (startedStudents, score) {
  const hasStudents = startedStudents !== null && startedStudents === 0
  const percentageLabel = (hasStudents || score === 0)
    ? '-- '
    : score
  let gradedDot = greenDot
  if (score < 70 || hasStudents) {
    gradedDot = redDot
  } else if (score < 90) {
    gradedDot = yellowDot
  }

  const dotImg = score > 0
    ? (
    <img
      key={score}
      src={gradedDot}
      className={classnames(iconStyle.small, style.gradedDotImg)}
      alt=""
      tabIndex="-1"
      aria-hidden="true"
    />
      )
    : null

  return ([
    dotImg,
    <label className={classnames(iconStyle.textIcon, iconStyle.textStudyPlanItem)}>{percentageLabel}%</label>
  ])
}

function StudyPlanItemActive (props) {
  const percentage = props.totalPointsAvailable
    ? Math.round(props.totalPointsEarned / props.totalPointsAvailable * 100)
    : 0

  const classPercentage = Math.round(props.classPointsEarned / props.classPointsAvailable * 100) || 0

  const originalPercentage = Math.round(props.originalPointsEarned / props.originalPointsAvailable * 100) || 0

  const { selectedStudent, classScoreSelected, originalScoreSelected } = props
  let labelValues = ''
  let labelOffset = '' // offset black dots
  let topicData = null

  function getOffsets (studentAccuracy) {
    const totalAccuracyRange = 100
    let initialOffset = 0
    let defaultOffset = null
    switch (true) {
      case props.width < 992:
        defaultOffset = 7
        break
      case props.width < 1200:
        defaultOffset = 5
        break
      default:
        defaultOffset = 4
        break
    }
    initialOffset = totalAccuracyRange - (totalAccuracyRange - studentAccuracy)
    if (studentAccuracy <= defaultOffset) {
      return defaultOffset
    } else {
      initialOffset -= defaultOffset
      return initialOffset
    }
  }

  if (props.hasQuestions) {
    if (props.classScoreSelected) {
      labelValues = `${classPercentage}%`
      labelOffset = `${getOffsets(classPercentage)}%`
    } else if (props.originalScoreSelected) {
      labelValues = `${originalPercentage}%`
      labelOffset = `${getOffsets(originalPercentage)}%`
    }

    const labelPostions = { left: labelOffset }
    topicData = ([
      <Col xs={10} sm={10} md={9} lg={10} key="progress-bar">
        <div className={style.progressBar}>
          <CustomProgressBar
            dataTestId="studyPlanItemProgressBar"
            now={percentage}
            min={0}
            max={100}
            ariaLabel={`You have ${percentage} points.`}
            progressBarStyle={progressBarStyle}
            style={style}
            className={classnames(progressBarStyle.base, style.progressBar)}
            bsClass={classnames(progressBarStyle.progressValueBase)}
          />
        </div>
        {renderBlackDot(labelValues, labelPostions, selectedStudent, classScoreSelected, originalScoreSelected)}
      </Col>,
      <Col xs={2} sm={2} md={3} lg={2} className={style.accuracyCol} key="percentage">
        <div className={style.percentage}>
          {renderGradedDot(props.startedStudents, percentage)}
        </div>
        <br className={classnames('hidden-sm', 'hidden-md', 'hidden-lg')} />
      </Col>
    ])
  } else {
    topicData = (
      <Col xs={12} sm={12} md={12} lg={12}>
        <div className={classnames(style.noQuestionsContainer)}>
          <span className={classnames(style.noQuestions)}>
            (No questions on this topic.)
          </span>
        </div>
      </Col>
    )
  }

  return (
    <div
      data-test-id="studyPlanItem"
      className={classnames(panelStyle.base, style.studyPanel)}
    >
      <Clickable
        data-test-id="studyPlanItemTitleBtn"
        onClick={props.onClick}
        aria-expanded={props.isExpanded}
        aria-label={'Reading for ' + props.label}
      >
        {props.isExpanded
          ? <img aria-hidden="true" className={style.topicCaret} src={caretDown} alt={'caret expanded'} />
          : <img aria-hidden="true" className={style.topicCaret} src={caretRight} alt={'caret collapsed'} />
        }
        <div
          data-test-id="studyPlanItemTitle"
          className={style.topicText}
          dangerouslySetInnerHTML={{ __html: props.label }}
        />
      </Clickable>

      <Row style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
        {topicData}
      </Row>
      {props.isExpanded
        ? <StudyPlanItemExpanded {...props} />
        : null
      }
    </div>
  )
}

StudyPlanItemActive.propTypes = {
  onClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  originalPointsAvailable: PropTypes.number.isRequired,
  originalPointsEarned: PropTypes.number.isRequired,
  classPointsAvailable: PropTypes.number.isRequired,
  classPointsEarned: PropTypes.number.isRequired,
  totalPointsAvailable: PropTypes.number.isRequired,
  totalPointsEarned: PropTypes.number.isRequired,
  hasQuestions: PropTypes.bool.isRequired,
  studyPlan: PropTypes.array,
  disableLinks: PropTypes.bool,
  startedStudents: PropTypes.number,
  selectedStudent: PropTypes.object,
  originalScoreSelected: PropTypes.bool.isRequired,
  classScoreSelected: PropTypes.bool.isRequired,
  width: PropTypes.number
}

function StudyPlanItemContainer (props) {
  return props.isActive ? <StudyPlanItemActive {...props} /> : <StudyPlanItemDisabled {...props} />
}

StudyPlanItemContainer.propTypes = {
  isActive: PropTypes.bool
}

export default class StudyPlanItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isExpanded: false
    }
  }

  toggleStudyPlan () {
    this.setState({ isExpanded: !this.state.isExpanded })
  }

  render () {
    return (
      <StudyPlanItemContainer
        onClick={this.toggleStudyPlan.bind(this)}
        isExpanded={this.state.isExpanded}
        {...this.props}
      />
    )
  }
}
